import ServiceBase from '@/services/ServiceBase';
import { OutboundDispatchStatusRequest } from '@/models/outboundDispatchStatus/OutboundDispatchStatusRequest';
import { OutboundDispatchStatusResponse } from '@/models/outboundDispatchStatus/OutboundDispatchStatusResponse';

class OutboundDispatchStatusService extends ServiceBase {
    getOutboundDispatchStatuses(
        userId: string,
        pageNumber = 1,
        pageSize = 50,
        filters?: any
    ): Promise<OutboundDispatchStatusResponse> {
        const request: OutboundDispatchStatusRequest = {
            userId: userId,
            pageNumber: pageNumber,
            pageSize: pageSize,
            ...(filters && {
                shipmentId: filters.shipmentId || null,
                status: filters.status || null,
                carrierId: filters.carrierId || null,
                carrierResponse: filters.carrierResponse || null,
                pickupNumber: filters.pickupNumber || null,
                shipmentCreatedDate: filters.shipmentCreatedDate || null,
                carrierNotifiedDate: filters.carrierNotifiedDate || null,
                responseDate: filters.responseDate || null,
                accountId: filters.accountId || null,
            })
        };

        return this.postWithRawResult<OutboundDispatchStatusResponse>('/api/outbound-dispatch-status', request, null);
    }
}

export default new OutboundDispatchStatusService(); 